import { render } from "./ViewToolbox.vue?vue&type=template&id=c4d18600"
import script from "./ViewToolbox.vue?vue&type=script&lang=js"
export * from "./ViewToolbox.vue?vue&type=script&lang=js"

import "./ViewToolbox.vue?vue&type=style&index=0&id=c4d18600&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.28.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__